(function () {

  'use strict';



  var SECTION_ID = 'gb-cart-drawer';

  var isUpdating = false;

  var lastFocusedElement = null;



  function rootUrl() {

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||

      (window.routes && window.routes.rootUrl) || '/';

    return root.slice(-1) === '/' ? root : root + '/';

  }



  function cartEndpoint(path) {

    return rootUrl() + 'cart' + path;

  }



  function drawer() {

    return document.getElementById('GBcartDrawer');

  }



  function parseError(response, fallback) {

    return response.json().then(function (data) {

      return data.description || data.message || fallback;

    }).catch(function () {

      return fallback;

    });

  }



  function setLoading(loading) {

    isUpdating = loading;

    var element = drawer();

    if (!element) return;

    element.classList.toggle('is-loading', loading);

    element.setAttribute('aria-busy', loading ? 'true' : 'false');

    element.querySelectorAll('button, input, a.gb-cart-drawer__checkout').forEach(function (control) {

      if (control.hasAttribute('data-gb-cart-close')) return;

      if (loading) control.setAttribute('aria-disabled', 'true');

      else control.removeAttribute('aria-disabled');

    });

  }



  function setStatus(message, type) {

    var element = drawer();

    if (!element) return;

    var status = element.querySelector('[data-gb-cart-status]');

    if (!status) return;

    status.textContent = message || '';

    status.classList.toggle('is-error', type === 'error');

    status.classList.toggle('is-success', type === 'success');

    status.hidden = !message;

  }



  function updateCartCount(cart) {

    if (!cart) return;

    var count = Number(cart.item_count || 0);

    document.querySelectorAll('.cart-info em').forEach(function (node) {

      node.textContent = count;

    });

    document.querySelectorAll('.cart-count-mobile').forEach(function (node) {

      node.textContent = count;

      node.hidden = count < 1;

    });

    document.querySelectorAll('.menu-cart').forEach(function (link) {

      link.classList.toggle('animated', count > 0);

      link.classList.toggle('bounce', count > 0);

    });

  }



  function fetchCart() {

    return fetch(cartEndpoint('.js'), {

      credentials: 'same-origin',

      headers: { Accept: 'application/json' }

    }).then(function (response) {

      if (!response.ok) throw new Error('Impossibile aggiornare il conteggio del carrello.');

      return response.json();

    });

  }



  function reinitializePaymentButtons() {

    if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') {

      window.Shopify.PaymentButton.init();

    }

  }



  // Mostra il suggerimento soltanto se ci sono almeno due righe prodotto
  // e l'elenco scorrevole contiene ancora articoli non visibili.
  function updateCartScrollHint() {
    var element = drawer();
    if (!element) return;
    var content = element.querySelector('.gb-cart-drawer__content');
    var hint = element.querySelector('.gb-cart-scroll-hint');
    if (!content || !hint) return;
    var distinctProducts = content.querySelectorAll('[data-gb-cart-item]').length;
    var canScrollFurther = content.scrollHeight - content.clientHeight - content.scrollTop > 8;
    var isOpen = element.getAttribute('aria-hidden') === 'false';
    hint.classList.toggle('is-visible', isOpen && distinctProducts >= 2 && canScrollFurther);
  }

  function setupCartScrollHint() {
    var element = drawer();
    if (!element) return;
    var content = element.querySelector('.gb-cart-drawer__content');
    if (!content) return;
    if (!element.querySelector('.gb-cart-scroll-hint')) {
      var hint = document.createElement('div');
      hint.className = 'gb-cart-scroll-hint';
      hint.setAttribute('aria-hidden', 'true');
      hint.innerHTML = '<span class="gb-cart-scroll-hint__arrow">↓</span> Scorri per vedere gli altri prodotti';
      content.insertAdjacentElement('afterend', hint);
    }
    if (content.dataset.gbScrollHintBound !== 'true') {
      content.dataset.gbScrollHintBound = 'true';
      content.addEventListener('scroll', updateCartScrollHint, { passive: true });
    }
    updateCartScrollHint();
  }

  function replaceDrawer(html, keepOpen) {

    var current = drawer();

    if (!current) return false;

    var parsed = new DOMParser().parseFromString(html, 'text/html');

    var replacement = parsed.getElementById('GBcartDrawer');

    if (!replacement) return false;

    replacement.setAttribute('aria-hidden', keepOpen ? 'false' : 'true');

    current.replaceWith(replacement);

    document.body.classList.toggle('gb-cart-open', keepOpen);

    reinitializePaymentButtons();
    setupCartScrollHint();

    return true;

  }



  function refreshDrawer(keepOpen) {

    var url = rootUrl() + '?section_id=' + encodeURIComponent(SECTION_ID) + '&_=' + Date.now();

    return fetch(url, {

      credentials: 'same-origin',

      headers: { Accept: 'text/html' }

    }).then(function (response) {

      if (!response.ok) throw new Error('Impossibile aggiornare il carrello.');

      return response.text();

    }).then(function (html) {

      if (!replaceDrawer(html, keepOpen)) throw new Error('La sezione del carrello non è disponibile.');

      return fetchCart();

    }).then(function (cart) {

      updateCartCount(cart);

      return cart;

    });

  }



  function showDrawer() {

    var element = drawer();

    if (!element) return;

    element.setAttribute('aria-hidden', 'false');

    document.body.classList.add('gb-cart-open');

    var closeButton = element.querySelector('.gb-cart-drawer__close');

    if (closeButton) closeButton.focus({ preventScroll: true });
    setupCartScrollHint();
    window.requestAnimationFrame(updateCartScrollHint);

  }



  function openDrawer() {

    if (isUpdating) return Promise.resolve();

    lastFocusedElement = document.activeElement;

    setLoading(true);

    return refreshDrawer(true).then(function () {

      showDrawer();

    }).catch(function (error) {

      console.error('[GB Cart Drawer]', error);

      showDrawer();

      setStatus(error.message, 'error');

    }).finally(function () {

      setLoading(false);

    });

  }



  function closeDrawer() {

    var element = drawer();

    if (!element) return;

    element.setAttribute('aria-hidden', 'true');

    document.body.classList.remove('gb-cart-open');

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {

      lastFocusedElement.focus({ preventScroll: true });

    }

  }



  function showError(message) {

    lastFocusedElement = document.activeElement;

    setLoading(true);

    return refreshDrawer(true).catch(function () {}).then(function () {

      showDrawer();

      setStatus(message || 'Non è stato possibile aggiornare il carrello.', 'error');

    }).finally(function () {

      setLoading(false);

    });

  }



  function changeQuantity(line, quantity) {

    if (isUpdating) return;

    setLoading(true);

    setStatus('', '');

    fetch(cartEndpoint('/change.js'), {

      method: 'POST',

      credentials: 'same-origin',

      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },

      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)) })

    }).then(function (response) {

      if (!response.ok) {

        return parseError(response, 'La quantità richiesta non è disponibile.').then(function (message) {

          throw new Error(message);

        });

      }

      return response.json();

    }).then(function (cart) {

      updateCartCount(cart);

      return refreshDrawer(true);

    }).catch(function (error) {

      return refreshDrawer(true).catch(function () {}).then(function () {

        setStatus(error.message, 'error');

      });

    }).finally(function () {

      setLoading(false);

    });

  }



  function applyDiscount(code) {

    if (isUpdating) return;

    var normalizedCode = String(code || '').trim();

    if (!normalizedCode) {

      setStatus('Inserisci un codice sconto.', 'error');

      return;

    }

    setLoading(true);

    setStatus('', '');

    fetch(cartEndpoint('/update.js'), {

      method: 'POST',

      credentials: 'same-origin',

      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },

      body: JSON.stringify({ discount: normalizedCode })

    }).then(function (response) {

      if (!response.ok) {

        return parseError(response, 'Non è stato possibile applicare il codice sconto.').then(function (message) {

          throw new Error(message);

        });

      }

      return response.json();

    }).then(function (cart) {

      updateCartCount(cart);

      var applied = Number(cart.total_discount || 0) > 0 ||

        (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0);

      return refreshDrawer(true).then(function () {

        setStatus(

          applied ? 'Codice sconto applicato.' : 'Il codice non è valido per gli articoli presenti nel carrello.',

          applied ? 'success' : 'error'

        );

      });

    }).catch(function (error) {

      setStatus(error.message, 'error');

    }).finally(function () {

      setLoading(false);

    });

  }



  function isCartLink(link) {

    if (!link || !link.href) return false;

    try {

      var url = new URL(link.href, window.location.origin);

      var expectedPath = rootUrl() + 'cart';

      return url.origin === window.location.origin &&

        url.pathname.replace(/\/$/, '') === expectedPath.replace(/\/$/, '');

    } catch (error) {

      return false;

    }

  }



  function focusTrap(event) {

    if (event.key !== 'Tab') return;

    var element = drawer();

    if (!element || element.getAttribute('aria-hidden') !== 'false') return;

    var controls = Array.prototype.slice.call(element.querySelectorAll(

      'a[href], button:not([disabled]), input:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'

    )).filter(function (control) {

      return control.offsetParent !== null && control.getAttribute('aria-disabled') !== 'true';

    });

    if (!controls.length) return;

    var first = controls[0];

    var last = controls[controls.length - 1];

    if (event.shiftKey && document.activeElement === first) {

      event.preventDefault();

      last.focus();

    } else if (!event.shiftKey && document.activeElement === last) {

      event.preventDefault();

      first.focus();

    }

  }



  document.addEventListener('click', function (event) {

    var close = event.target.closest('[data-gb-cart-close]');

    if (close) {

      event.preventDefault();

      closeDrawer();

      return;

    }

    var change = event.target.closest('[data-gb-cart-change]');

    if (change) {

      event.preventDefault();

      if (change.disabled || change.getAttribute('aria-disabled') === 'true') return;

      changeQuantity(change.dataset.line, change.dataset.quantity);

      return;

    }

    var checkout = event.target.closest('[data-gb-checkout]');

    if (checkout) {

      document.dispatchEvent(new CustomEvent('gb:begin-checkout'));

      return;

    }

    var link = event.target.closest('a[href]');

    if (link && isCartLink(link) && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {

      event.preventDefault();

      openDrawer();

    }

  });



  document.addEventListener('submit', function (event) {

    var form = event.target.closest('[data-gb-discount-form]');

    if (!form) return;

    event.preventDefault();

    var input = form.querySelector('input[name="discount"]');

    applyDiscount(input ? input.value : '');

  });



  document.addEventListener('keydown', function (event) {

    var element = drawer();

    if (!element || element.getAttribute('aria-hidden') !== 'false') return;

    if (event.key === 'Escape') {

      event.preventDefault();

      closeDrawer();

      return;

    }

    focusTrap(event);

  });



  window.addEventListener('resize', updateCartScrollHint, { passive: true });
  setupCartScrollHint();

  window.GBCartDrawer = {

    open: openDrawer,

    close: closeDrawer,

    refresh: function () {

      return refreshDrawer(drawer() && drawer().getAttribute('aria-hidden') === 'false');

    },

    showError: showError

  };

})();
